<template>
  <div class="book-carousel">
    <div class="tab-bar-wrapper">
      <img
        :src="require('@/assets/images/leftborder.png')"
        alt=""
        class="wrapper-image"
        @click="scrollLeft"
      />
      <div class="tab-bar" ref="tabBar">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'recommandedBook' }"
          @click="activeTab = 'recommandedBook'"
        >
          推荐书目
        </div>
        <!-- <div
          class="tab-item"
          :class="{ active: activeTab === 'freeBook' }"
          @click="activeTab = 'freeBook'"
        >
          免费图书
        </div> -->
        <div
          class="tab-item"
          v-for="item in tabs"
          :key="item.id || item.name"
          :class="{ active: activeTab === item }"
          @click="activeTab = item"
        >
          {{ item.name }}
        </div>
      </div>
      <img
        :src="require('@/assets/images/rightborder.png')"
        alt=""
        class="wrapper-image"
        @click="scrollRight"
      />
    </div>
    <div class="book-carousel-inner">
      <img
        :src="larrow"
        alt="arrow"
        class="arrow"
        @click="prev"
        @mouseenter="handleMouseEnterl"
        @mouseleave="handleMouseLeavel"
      />
      <el-carousel
        :autoplay="false"
        arrow="never"
        ref="carousel"
        indicator-position="none"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="加载中"
      >
        <el-carousel-item v-for="item in counter" :key="item">
          <div class="book-cards">
            <div
              v-for="book in carouselData[item]"
              :key="book.id"
              class="book-card"
            >
              <img
                :src="book.image"
                data-warden-title="显示文章内容"
                :data-warden-bookId="book.bookId"
                :data-warden-info="book.name"
                alt="中医古籍"
                class="book-cover"
                @click="jumpToBook(book.id)"
              />
              <div
                class="book-title"
                data-warden-title="显示文章内容"
                :data-warden-bookId="book.bookId"
                :data-warden-info="book.name"
                @click="jumpToBook(book.id)"
              >
                <span>{{ book.name }}</span>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <img
        :src="rarrow"
        alt="arrow"
        class="arrow"
        @click="next"
        @mouseenter="handleMouseEnterr"
        @mouseleave="handleMouseLeaver"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookCarousel',
  props: {},
  data () {
    return {
      activeTab: 'recommandedBook',
      carouselData: [],
      larrow: require('@/assets/images/leftarrow.png'),
      rarrow: require('@/assets/images/rightarrow.png'),
      counter: [],
      loading: false,
      tabs: []
    }
  },
  mounted () {
    this.syncAiChatCategory(this.activeTab)
    this.getRecommandBooks()
    this.getSubjectList()
  },
  methods: {
    syncAiChatCategory (tab) {
      let category = {
        categoryType: 'common',
        categoryValue: 'common',
        categoryName: '通用问题'
      }
      if (tab && typeof tab === 'object' && tab.id !== undefined) {
        category = {
          categoryType: 'subject',
          categoryValue: String(tab.id),
          categoryName: tab.name || ''
        }
      }
      this.$global.aiChatCategory = category
      localStorage.setItem('aiChatCategory', JSON.stringify(category))
      if (this.$bus) {
        this.$bus.$emit('ai-chat-category-change', category)
      }
    },
    scrollLeft () {
      // 平滑滚动
      let tabbar = this.$refs.tabBar
      let currentScroll = tabbar.scrollLeft
      let targetScroll = currentScroll - 1000
      let step = 0
      let timer = setInterval(() => {
        step += 10
        tabbar.scrollLeft = currentScroll - (currentScroll - targetScroll) * step / 300
        if (step >= 300) {
          clearInterval(timer)
        }
      }, 10)
    },
    scrollRight () {
      // 平滑滚动
      let tabbar = this.$refs.tabBar
      let currentScroll = tabbar.scrollLeft
      let targetScroll = currentScroll + 1000
      let step = 0
      let timer = setInterval(() => {
        step += 10
        tabbar.scrollLeft = currentScroll + (targetScroll - currentScroll) * step / 300
        if (step >= 300) {
          clearInterval(timer)
        }
      }, 10)
    },
    prev () {
      this.$refs.carousel.prev()
    },
    next () {
      this.$refs.carousel.next()
    },
    handleMouseEnterl () {
      this.larrow = require('@/assets/images/leftarrowon.png')
    },
    handleMouseLeavel () {
      this.larrow = require('@/assets/images/leftarrow.png')
    },
    handleMouseEnterr () {
      this.rarrow = require('@/assets/images/rightarrowon.png')
    },
    handleMouseLeaver () {
      this.rarrow = require('@/assets/images/rightarrow.png')
    },
    jumpToBook (id) {
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {
          book: id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    clearBooks () {
      this.carouselData.splice(0, this.carouselData.length)
      this.counter.splice(0, this.counter.length)
    },
    getFreeBooks () {
      this.loading = true
      let url = '/retrieve/search/getFreeBooks'
      this.$http
        .get(url)
        .then(res => {
          this.clearBooks()
          for (let i = 0; i < res.data.data.searchRes.length; i++) {
            let image = require('@/assets/images/bookCover/u553.jpg')
            this.carouselData.push({
              id: res.data.data.searchRes[i].id,
              name: res.data.data.searchRes[i].bookName,
              image: image
            })
          }
          this.loading = false
          return this.carouselData
        })
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            let url = '/retrieve/page/getImage'
            this.$http({
              method: 'get',
              url: url,
              params: {
                bookId: res[i].id,
                page: 1
              },
              responseType: 'blob'
            }).then(res1 => {
              let blob = new Blob([res1.data], { type: 'image/jpg' })
              let url = window.URL.createObjectURL(blob)
              console.log(url)
              res[i].image = url
            })
          }
          this.carouselData = res
          return this.carouselData
        })
        .then(res => {
          for (let i = 0; i < res.length / 5; i++) {
            this.counter.push(i)
          }
          // 将数据分成5个一组
          let temp = []
          for (let i = 0; i < res.length; i++) {
            if (i % 5 === 0) {
              temp.push([])
            }
            temp[temp.length - 1].push(res[i])
          }
          this.carouselData = temp
        })
    },
    getRecommandBooks () {
      this.loading = true
      let url = 'retrieve/search/getRecommendedBooks'
      if (this.$route.params.url) {
        url += '?libraryStrict=' + localStorage.getItem('sublibrary')
      }
      this.$http
        .get(url)
        .then(res => {
          this.clearBooks()
          for (let i = 0; i < res.data.data.searchRes.length; i++) {
            let image = require('@/assets/images/bookCover/u553.jpg')
            this.carouselData.push({
              id: res.data.data.searchRes[i].id,
              name: res.data.data.searchRes[i].bookName,
              image: image
            })
          }
          this.loading = false
          return this.carouselData
        })
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            let url = '/retrieve/page/getImage'
            this.$http({
              method: 'get',
              url: url,
              params: {
                bookId: res[i].id,
                page: 1
              },
              responseType: 'blob'
            }).then(res1 => {
              let blob = new Blob([res1.data], { type: 'image/jpg' })
              let url = window.URL.createObjectURL(blob)
              console.log(url)
              res[i].image = url
            })
          }
          this.carouselData = res
          return this.carouselData
        })
        .then(res => {
          for (let i = 0; i < res.length / 5; i++) {
            this.counter.push(i)
          }
          // 将数据分成5个一组
          let temp = []
          for (let i = 0; i < res.length; i++) {
            if (i % 5 === 0) {
              temp.push([])
            }
            temp[temp.length - 1].push(res[i])
          }
          this.carouselData = temp
        })
    },
    getBooks (id) {
      this.loading = true
      let url = '/retrieve/book/getAllBookBySubject'
      let params = new URLSearchParams()
      params.append('subjectId', id + '')
      this.$http
        .post(url, params)
        .then(res => {
          this.clearBooks()
          for (let i = 0; i < res.data.data.length; i++) {
            let image = require('@/assets/images/bookCover/u553.jpg')
            this.carouselData.push({
              id: res.data.data[i].id,
              name: res.data.data[i].bookName,
              image: image
            })
          }
          this.loading = false
          return this.carouselData
        })
        .then(res => {
          for (let i = 0; i < res.length; i++) {
            let url = '/retrieve/page/getImage'
            this.$http({
              method: 'get',
              url: url,
              params: {
                bookId: res[i].id,
                page: 1
              },
              responseType: 'blob'
            }).then(res1 => {
              let blob = new Blob([res1.data], { type: 'image/jpg' })
              let url = window.URL.createObjectURL(blob)
              console.log(url)
              res[i].image = url
            })
          }
          this.carouselData = res
          return this.carouselData
        })
        .then(res => {
          for (let i = 0; i < res.length / 5; i++) {
            this.counter.push(i)
          }
          // 将数据分成5个一组
          let temp = []
          for (let i = 0; i < res.length; i++) {
            if (i % 5 === 0) {
              temp.push([])
            }
            temp[temp.length - 1].push(res[i])
          }
          this.carouselData = temp
        })
    },
    getSubjectList () {
      let url = '/retrieve/book/getAllPublicSubjectList'
      this.$http.post(url).then(res => {
        let list = res.data.data.data
        console.log(list)
        for (let subject of list) {
          this.tabs.push(subject)
        }
      })
    }
  },
  computed: {},
  watch: {
    activeTab (newVal, oldVal) {
      this.syncAiChatCategory(newVal)
      this.clearBooks()
      if (newVal === 'freeBook') {
        this.getFreeBooks()
      } else if (newVal === 'recommandedBook') {
        this.getRecommandBooks()
      } else {
        this.getBooks(newVal.name)
      }
    }
  }
}
</script>

<style scoped>
.book-carousel-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.book-carousel-inner >>> .el-carousel {
  width: 100%;
}

.book-carousel-inner >>> .el-carousel__container {
  height: 417px !important;
}

.arrow {
  width: 60px;
  height: 60px;
  margin: 0 10px;
  cursor: pointer;
  /* margin: 0 107px; */
}

.tab-bar-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.tab-bar {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  height: 50px;
  width: 1150px;
  background-color: #fff;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-right: 30px;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.tab-bar-wrapper img {
  margin: 0 -25px;
}

.tab-item {
  text-align: center;
  font-size: 18px;
  color: #b47f4d;
  min-width: 100px;
  cursor: pointer;
  padding-bottom: 10px;
  font-weight: bold;
  margin-left: 40px;
  border: 2px solid transparent;
}

.tab-item.active {
  color: #9d5a1a;
  border-bottom: 2px solid #9d5a1a;
}

.book-carousel-inner >>> .el-carousel {
  width: 1184px;
  background-color: #f4e9de;
  border-top: 10px solid #eee1d3;
  padding: 20px 10px;
}

.book-carousel-inner >>> .el-carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.book-cards {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.book-card {
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin: 10px;
}

.book-cover {
  width: 196px;
  height: 278px;
  margin: 5px;
  cursor: pointer;
  transition: all 0.3s;
}

.book-cover:hover {
  transform: scale(1.05);
}

.book-title {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #9e5c1d;
}

.book-title span {
  cursor: pointer;
}

.wrapper-image {
  height: 50px;
  cursor: pointer;
  transition: all 0.3s;
}

.wrapper-image:hover {
  opacity: 0.8;
}

.book-carousel-inner >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.book-carousel-inner >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/BookCarousel.vue